import React from 'react';
import { TabItem } from '../types';

interface TabBarProps {
    activeTab: string;
    setActiveTab: (tab: string) => void;
    tabItems: TabItem[];
}

const TabBar: React.FC<TabBarProps> = ({
    activeTab,
    setActiveTab,
    tabItems,
}) => (
    <div className="flex justify-center w-full mt-6">
        <div className="flex gap-2 px-2 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 shadow-lg">
            {tabItems.map((tab) => {
                const isActive = activeTab === tab.key;
                const Icon = tab.icon;
                return (
                    <button
                        key={tab.key}
                        onClick={() => setActiveTab(tab.key)}
                        className={`flex items-center gap-2 px-5 py-2 rounded-full font-semibold text-sm sm:text-base transition-all duration-300
                            ${isActive
                                ? 'bg-gradient-to-r from-yellow-400 to-yellow-600 text-white shadow-lg scale-105'
                                : 'bg-transparent text-white border border-white/30 hover:bg-yellow-400/20 hover:text-yellow-400'}
                        `}
                        style={{ fontWeight: isActive ? 700 : 500 }}
                    >
                        <Icon className="w-5 h-5" />
                        <span>{tab.label}</span>
                    </button>
                );
            })}
        </div>
    </div>
);

export default TabBar; 